import React, { Component } from "react";
import { GET, POST, alert, loading, t } from "../../../components/CustomComponent.js";
import Logo from "../../../components/Logo.js";
import { isPartnerUser } from "../../../components/people_option.js";
import ICON from "../icons.js";
import Turnstile from "react-turnstile";
import { CAPTCHA_SITE_KEY, isCaptchaEnabled } from "../../../utils/captcha.js";
// ให้แน่ใจว่า global.getAdminHomeLink ถูกประกาศแล้วแม้หน้านี้ถูกเปิดตรง ๆ (import ซ้ำได้)
import "../../../components/global.js";

/* ============================================================================
 * HomeLoginModal — กล่องเข้าสู่ระบบหลังบ้าน เปิดจากปุ่มบนแถบเมนูของหน้าสาธารณะ
 *
 * เป็นทางเข้าเดียวกับหน้า /login แต่ไม่พาผู้ใช้ออกจากหน้าที่กำลังดูอยู่ — คนที่
 * กำลังไล่ดูทรัพย์แล้วนึกได้ว่าต้องเข้าหลังบ้าน จะได้ไม่เสียตำแหน่งที่เลื่อนค้างไว้
 *
 * วางเป็น 2 คอลัมน์แบบเดียวกับหน้า /login (แผงแบรนด์ซ้าย · ฟอร์มขวา) และใช้ทั้ง
 * รูปกับข้อความชุดเดียวกับหน้านั้น (ex-login.jpeg, hero_* , feature_*) กล่องนี้จึง
 * เป็นหน้าเดียวกับที่ผู้ใช้เคยเห็น ไม่ใช่กล่องขาว ๆ ที่หลุดออกมาจากธีมของระบบ
 * จอเล็กกว่า 768px ซ่อนแผงแบรนด์ เหลือเฉพาะฟอร์มเต็มจอ
 *
 * ท้ายกล่องมีทางไป "สมัครเป็นพาร์ตเนอร์" เพราะคนที่กดเข้าสู่ระบบแล้วพบว่าตัวเอง
 * ยังไม่มีบัญชี คือกลุ่มเป้าหมายของใบสมัครพอดี — ปิดกล่องแล้วพาไป /partner
 *
 * ต่อกับ API แล้ว — ใช้ลำดับเดียวกับหน้า /login ทุกขั้น (POST auth/login → เก็บ token
 * → GET admin/users/profile → เด้งไปหน้าแรกตามสิทธิ์ของบทบาท) จึงไม่มีทางที่สอง
 * ทางเข้านี้จะให้ผลต่างกัน
 *
 * รับทุกประเภทบัญชี — ไม่ส่ง scope ขึ้นไปกับคำขอ (ไม่ส่ง = ไม่จำกัดประเภท เหมือน /login)
 * เดิมกล่องนี้ส่ง scope: "partner" เพื่อให้ backend ปฏิเสธบัญชีประเภทอื่นตั้งแต่ก่อนออก
 * token แต่ผู้ดูแลระบบที่กำลังเปิดหน้าเว็บฝั่งลูกค้าอยู่ก็ต้องเข้าระบบจากตรงนี้ได้ ไม่ต้อง
 * ย้อนไปพิมพ์ /login เอง — ด่านฝั่ง backend ยังอยู่ครบ (LOGIN_SCOPES ใน user.constant.js)
 * เผื่อวันหนึ่งต้องกลับมากันอีก แค่ทางเข้านี้ไม่ได้เรียกใช้แล้ว
 *
 * ปลายทางหลังล็อกอินคิดจากประเภทบัญชี :
 * - พาร์ตเนอร์ : อยู่หน้าเดิม แค่โหลดใหม่ให้แถบเมนูรู้ว่าล็อกอินแล้ว — กล่องนี้เปิดได้จาก
 *   ทุกหน้าสาธารณะ รวมถึงหน้ารายละเอียดทรัพย์ที่เลื่อนค้างไว้ ลากออกไปเท่ากับพาหลุดจาก
 *   สิ่งที่กำลังดูอยู่ ทางเข้าหลังบ้านอยู่ที่ปุ่มในเมนูโปรไฟล์บนแถบเมนูแทน
 *   (ดู adminLink ใน HomeNavbar)
 * - ผู้ดูแลระบบ/ทีมงาน : เด้งเข้าหลังบ้านตามสิทธิ์ของบทบาทให้เลย (global.getAdminHomeLink)
 *   สูตรเดียวกับหน้า /login — คนกลุ่มนี้ล็อกอินเพื่อไปทำงาน ไม่ใช่เพื่อดูหน้าเว็บต่อ
 * ========================================================================== */

/* จุดขายในแผงแบรนด์ — คีย์เดียวกับที่หน้า /login ใช้ จะได้แก้ที่เดียวแล้วตรงกันสองที่ */
const HIGHLIGHTS = ["feature_manage_property", "feature_customer_owner", "feature_realtime_report"];

export default class HomeLoginModal extends Component {
  /* จำอีเมลไว้ด้วยคีย์เดียวกับหน้า /login — คนที่เคยติ๊ก "จำฉันไว้" ที่หน้าใดหน้าหนึ่ง
     จะได้ไม่ต้องพิมพ์ใหม่เมื่อกลับมาเข้าจากอีกหน้า */
  state = {
    email: localStorage.getItem("mn-remember-email") || "",
    password: "",
    password_view: "password",
    remember: !!localStorage.getItem("mn-remember-email"),
    sending: false,
    // ผลจากวิดเจ็ต Turnstile — ว่างไว้เสมอเมื่อยังไม่ได้ตั้งค่า (ดู utils/captcha.js)
    token: "",
    captchaKey: 0,
  };

  emailRef = React.createRef();

  componentDidMount() {
    window.addEventListener("keydown", this.onKey);
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.open && this.props.open) {
      document.body.classList.add("hm-lg-noscroll"); // กันหน้าเว็บด้านหลังเลื่อนตาม
      // โฟกัสช่องแรกให้เลย คนที่เปิดกล่องนี้มาเพื่อพิมพ์ ไม่ใช่มาอ่าน
      setTimeout(() => this.emailRef.current?.focus(), 0);
    }
    if (prevProps.open && !this.props.open) document.body.classList.remove("hm-lg-noscroll");
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.onKey);
    document.body.classList.remove("hm-lg-noscroll");
  }

  onKey = (event) => {
    if (this.props.open && event.key === "Escape") this.props.onClose();
  };

  /* ยังไม่ต่อ API — แจ้งแบบเดียวกับเมนู coming soon ที่อื่นในเว็บ */
  soon = (name) => alert("", "info", t("coming_soon_title"), `${name} — ${t("coming_soon_desc")}`, t("confirm"));

  Login = async () => {
    const { email, password, remember, sending, token } = this.state;

    if (sending) return;
    if (!email.trim()) return alert("", "warning", t("warning"), t("verify_email"), t("confirm"));
    if (!password) return alert("", "warning", t("warning"), t("verify_password"), t("confirm"));
    // วิดเจ็ตยังตรวจไม่เสร็จ — บอกให้รอ ดีกว่าปล่อยไปให้ backend ตีกลับว่าไม่ผ่าน
    if (isCaptchaEnabled() && !token) return alert("", "warning", t("warning"), t("verify_captcha"), t("confirm"));

    this.setState({ sending: true });
    loading(true);
    /* backend ถอด base64 ก่อนเทียบรหัสผ่าน จึงต้องส่งแบบเข้ารหัสไว้ (เหมือนหน้า /login)
       ไม่ส่ง scope = ไม่จำกัดประเภทบัญชี ทั้งพาร์ตเนอร์และผู้ดูแลระบบเข้าจากกล่องนี้ได้ */
    const result = await POST("auth/login", {
      email: email.trim(),
      password: btoa(password),
      ...(token ? { captcha_token: token } : {}),
    });

    // POST แจ้ง error ให้แล้วเมื่อ status ไม่เป็น true จึงไม่ต้อง alert ซ้ำ
    if (result?.status !== true) {
      loading(false);
      /* ผลจาก Turnstile ใช้ได้ครั้งเดียว ส่งไปตรวจแล้วถือว่าหมดอายุทันที ต้องสั่งให้
         วิดเจ็ตออกตัวใหม่ ไม่งั้นคนที่พิมพ์รหัสผ่านผิดจะติดอยู่กับผลเดิมที่ใช้ไม่ได้แล้ว
         (เปลี่ยน key = บังคับให้ React สร้างวิดเจ็ตใหม่ทั้งตัว — สูตรเดียวกับหน้า /login) */
      this.setState({
        sending: false,
        ...(isCaptchaEnabled() ? { token: "", captchaKey: this.state.captchaKey + 1 } : {}),
      });
      return;
    }

    if (remember) localStorage.setItem("mn-remember-email", email.trim());
    else localStorage.removeItem("mn-remember-email");

    localStorage.setItem("mn-acc-tk", btoa("Bearer " + result.data.token));

    /* login คืนมาแค่ token — สิทธิ์ของบทบาทต้องดึงจากโปรไฟล์
       เพราะแถบเมนู PermissionRoute และ can() ทั้งระบบอ่านจาก mn-profile */
    const profile = await GET("admin/users/profile");
    if (profile?.status !== true) {
      localStorage.clear();
      loading(false);
      this.setState({ sending: false });
      return;
    }

    localStorage.setItem("mn-profile", JSON.stringify(profile.data));

    /* ทีมงาน (super_user / admin) เข้ามาเพื่อไปทำงานหลังบ้าน จึงพาไปหน้าแรกตามสิทธิ์
       ของบทบาทให้เลย แบบเดียวกับหน้า /login ไม่ต้องกดต่อจากเมนูโปรไฟล์อีกทอด */
    if (!isPartnerUser(profile.data)) {
      window.location.href = global.getAdminHomeLink(profile.data);
      return;
    }

    /* พาร์ตเนอร์อยู่หน้าเดิม แค่โหลดใหม่ให้แถบเมนูรู้ว่าล็อกอินแล้ว — คนที่กดเข้าสู่ระบบ
       จากหน้ารายละเอียดทรัพย์จะได้ไม่ถูกเตะออกจากหน้าที่กำลังดูอยู่ */
    window.location.reload();
  };

  /* พาไปหน้าตั้งรหัสผ่านใหม่ — ปิดกล่องก่อนเสมอ ไม่งั้นกล่องจะค้างทับหน้าที่เพิ่งเปิด
     คอมโพเนนต์นี้ไม่ได้ห่อด้วย withRouter (HomeNavbar เป็นตัวห่อ) จึงรับมาเป็น prop
     แบบเดียวกับ onPartner */
  goForgot = () => {
    this.props.onClose();
    this.props.onForgot();
  };

  /* ปิดกล่องก่อนแล้วค่อยเปลี่ยนหน้า — ไม่งั้นกล่องจะค้างทับหน้าใบสมัครที่เพิ่งเปิด */
  goPartner = () => {
    this.props.onClose();
    this.props.onPartner();
  };

  render() {
    const { open, onClose } = this.props;
    const { email, password, password_view, remember, sending, captchaKey } = this.state;

    if (!open) return null;

    const hidden = password_view === "password";

    return (
      <div className="hm-lg" role="dialog" aria-modal="true" aria-labelledby="hm-lg-title">
        {/* คลิกพื้นหลังเพื่อปิด — เป็นปุ่มจริงเพื่อให้คีย์บอร์ดกดถึงได้ด้วย */}
        <button type="button" className="hm-lg__scrim" aria-label={t("cancel")} onClick={onClose} />

        <div className="hm-lg__box">
          <button type="button" className="hm-lg__close" aria-label={t("cancel")} onClick={onClose}>
            <span className="hm-ico">{ICON.close}</span>
          </button>

          {/* ---------------------------------------- ซ้าย : แผงแบรนด์
              aria-hidden เพราะเป็นภาพจำของแบรนด์ ไม่ใช่สิ่งที่ต้องอ่านก่อนกรอกฟอร์ม
              โปรแกรมอ่านหน้าจอจะได้พาไปที่ช่องกรอกเลย */}
          <aside className="hm-lg__aside" aria-hidden="true">
            <span className="hm-lg__aside-photo" />
            <span className="hm-lg__aside-veil" />
            <span className="hm-lg__aside-wedge" />

            <div className="hm-lg__aside-body">
              <span className="hm-lg__aside-kicker">SafeSpace Life Living</span>
              <h3 className="hm-lg__aside-title">
                {t("hero_title")} <em>{t("hero_highlight")}</em> {t("hero_title_end")}
              </h3>
              <ul className="hm-lg__aside-list">
                {HIGHLIGHTS.map((key) => (
                  <li key={key}>
                    <span className="hm-lg__aside-tick hm-ico">{ICON.check}</span>
                    {t(key)}
                  </li>
                ))}
              </ul>
            </div>
          </aside>

          {/* ---------------------------------------- ขวา : ฟอร์ม */}
          <div className="hm-lg__panel">
            <div className="hm-lg__head">
              <Logo size={40} />
              <h2 className="hm-lg__title" id="hm-lg-title">{t("login_title")}</h2>
              <p className="hm-lg__desc">{t("home_login_desc")}</p>
            </div>

            <div className="hm-lg__body">
              <label className="hm-lg__field">
                <span className="hm-lg__field-icon hm-ico">{ICON.user}</span>
                <input
                  ref={this.emailRef}
                  type="text"
                  className="hm-lg__input"
                  placeholder={t("placeholder_email_or_phone")}
                  value={email}
                  onChange={(e) => this.setState({ email: e.target.value })}
                  onKeyUp={(e) => e.key === "Enter" && this.Login()}
                />
              </label>

              <label className="hm-lg__field">
                <span className="hm-lg__field-icon hm-ico">{ICON.lock}</span>
                <input
                  type={password_view}
                  className="hm-lg__input"
                  placeholder={t("password")}
                  value={password}
                  onChange={(e) => this.setState({ password: e.target.value })}
                  onKeyUp={(e) => e.key === "Enter" && this.Login()}
                />
                <button
                  type="button"
                  className="hm-lg__toggle"
                  aria-label={t("password")}
                  aria-pressed={!hidden}
                  onClick={() => this.setState({ password_view: hidden ? "text" : "password" })}
                >
                  <span className="hm-ico">{hidden ? ICON.eye : ICON.eye_slash}</span>
                </button>
              </label>

              <div className="hm-lg__row">
                <label className="hm-lg__check">
                  <input
                    type="checkbox"
                    checked={remember}
                    onChange={(e) => this.setState({ remember: e.target.checked })}
                  />
                  <span>{t("remember_me")}</span>
                </label>

                <button type="button" className="hm-lg__link" onClick={this.goForgot}>
                  {t("forgot_password")}
                </button>
              </div>

              {/* CAPTCHA — ประตูนี้ต้องมีเหมือนหน้า /login ไม่งั้นการเปิดใช้ที่นั่นจะไร้ผล
                  เพราะคนโจมตียังยิงผ่านกล่องนี้ซึ่งไปที่ auth/login เส้นเดียวกันได้อยู่ดี */}
              {isCaptchaEnabled() && (
                <div className="hm-lg__captcha">
                  <Turnstile
                    key={captchaKey}
                    size="flexible"
                    sitekey={CAPTCHA_SITE_KEY}
                    onVerify={(token) => this.setState({ token })}
                    onExpire={() => this.setState({ token: "" })}
                    onError={() => this.setState({ token: "" })}
                  />
                </div>
              )}

              <button type="button" className="hm-lg__submit" disabled={sending} onClick={this.Login}>
                {sending ? t("signing_in") : t("sign_in")}
                <span className="hm-ico">{ICON.arrow_right}</span>
              </button>
            </div>

            {/* ทางไปใบสมัคร — คนที่กดเข้าสู่ระบบแล้วยังไม่มีบัญชีคือกลุ่มเป้าหมายพอดี */}
            <div className="hm-lg__partner">
              <div className="hm-lg__partner-text">
                <b>{t("home_login_no_account")}</b>
              </div>
              <button type="button" className="hm-lg__partner-btn" onClick={this.goPartner}>
                <span className="hm-ico">{ICON.handshake}</span>
                {t("partner_cta")}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
